import { CombinedFixes } from './autoTaskRow.ts';

interface Props {
    row: CombinedFixes;
    onClick: () => void;
}

// Opens the machine list. Each preview coordinate shows whether that machine is operating.
export function FixInProgressRow({ row, onClick }: Props) {
    return (
        <tr
            style={{ margin: '8px 8px', cursor: 'pointer', color: 'black' }}
            onClick={onClick}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    onClick();
                }
            }}
            role='button'
            tabIndex={0}
        >
            <td colSpan={3} className='textAlignLeft tasks--large-text'>
                ({row.tasks.length})
                {row.preview.map((machine, index) => {
                    const color = machine.isInOperate ? 'green' : 'black';
                    return (
                        <span key={machine.equipment} style={{ color }}>
                            {index === 0 ? ' ' : ', '}{machine.coordinates}
                        </span>
                    );
                })}
                {row.remainder > 0 && ` (+${row.remainder} more)`}
            </td>
            <td className='tasks--large-text'>Fix in progress</td>
        </tr>
    );
}
